import React from 'react';
import './Tabs.css';

class Tabs extends React.Component {
  render() {
    const getEvent = this.props.showDetails

    const items = this.props.data.map((item, id) => {
      return (
        <div className="tabs-nav-item" key={id}>
          <a className="tabs-nav-link" onClick={getEvent.bind(this, id)}>
            <h5 className="tabs-nav-item-title">{item.label}</h5>
            <h6 className="tabs-nav-item-subtitle">{item.year}</h6>
          </a>
        </div>
      )
    })

    return <nav className="tabs-nav">{items}</nav>
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/Shared/Tabs.js